import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getProcedureRunUIString, StringCase} from 'procedures/ProceduresStringKeys';

/**
 * Extract the procedure-related id (stdy_…, prp_…, or pcr_…) from a procedure
 * tool call's args, or null if the tool is not procedure-aware or the id is absent.
 */
export function getProcedureToolId(toolName: string, args?: Record<string, unknown>): string | null {
  if (args == null) {
    return null;
  }
  let value: unknown;
  switch (toolName) {
    case 'CreateProcedureRunPlan':
      value = args.study_id;
      break;
    case 'ValidateProcedureRunPlan':
    case 'PromoteProcedureRunPlan':
    case 'UpdateProcedureRunPlanConditions':
      value = args.procedure_run_plan_id;
      break;
    case 'CreateProcedureRunParameterValue':
      value = args.procedure_run_id;
      break;
    default:
      return null;
  }
  if (typeof value !== 'string' || value.length === 0) {
    return null;
  }
  return value;
}

export function getProcedureRunPlanLabel(
  toolName: string,
  isCompleted: boolean,
  procedureType: ProcedureType
): string {
  const runWord = getProcedureRunUIString(procedureType, {stringCase: StringCase.LOWER});
  switch (toolName) {
    case 'CreateProcedureRunPlan':
      return isCompleted ? `Created ${runWord} plan` : `Creating ${runWord} plan`;
    case 'ValidateProcedureRunPlan':
      return isCompleted ? `Checked ${runWord} plan for errors` : `Checking ${runWord} plan for errors`;
    case 'PromoteProcedureRunPlan':
      return isCompleted ? `Created ${runWord}` : `Creating ${runWord}`;
    case 'UpdateProcedureRunPlanConditions':
      return isCompleted ? `Updated ${runWord} plan conditions` : `Updating ${runWord} plan conditions`;
    case 'CreateProcedureRunParameterValue':
      return isCompleted ? `Recorded ${runWord} parameter value` : `Recording ${runWord} parameter value`;
    default:
      return '';
  }
}
